import { useTranslation } from 'react-i18next';
import { FadeUp, Stagger, StaggerItem } from '../components/Motion';
import { Sprout, Factory, GraduationCap, FlaskConical, Users, Leaf } from 'lucide-react';

const ICONS = [Sprout, Factory, GraduationCap, FlaskConical, Users, Leaf];
const IMAGES = [
  'https://customer-assets.emergentagent.com/job_climate-resilience-5/artifacts/byggk5ef_IMG_7084.jpeg',
  'https://customer-assets.emergentagent.com/job_climate-resilience-5/artifacts/qaldt8ae_IMG_7078.jpeg',
  'https://customer-assets.emergentagent.com/job_climate-resilience-5/artifacts/80q3wm8o_IMG_7085.jpeg',
  'https://customer-assets.emergentagent.com/job_climate-resilience-5/artifacts/x3q6q38m_IMG_7082.jpeg',
  'https://customer-assets.emergentagent.com/job_climate-resilience-5/artifacts/ii7pxtng_IMG_7088.jpeg',
  'https://customer-assets.emergentagent.com/job_climate-resilience-5/artifacts/wlaur6fq_IMG_7083.jpeg',
];
export default function Activities() {
  const { t } = useTranslation();
  const items = t('activities.items', { returnObjects: true });

  return (
    <main data-testid="activities-page" className="pt-32">
      <section className="container-x max-w-7xl mx-auto pb-16">
        <FadeUp>
          <p className="overline">{t('activities.overline')}</p>
          <h1 className="mt-4 font-heading text-5xl sm:text-6xl lg:text-7xl text-ink tracking-tight max-w-4xl text-balance">
            {t('activities.title')}
          </h1>
          <p className="mt-6 text-lg text-ink-soft max-w-2xl leading-relaxed">{t('activities.intro')}</p>
        </FadeUp>
      </section>

      <section className="container-x max-w-7xl mx-auto pb-24">
        <Stagger className="grid gap-12 lg:gap-16">
          {items.map((it, i) => {
            const Icon = ICONS[i];
            const reverse = i % 2 === 1;
            return (
              <StaggerItem key={it.t}>
                <div className={`grid gap-10 lg:grid-cols-12 items-center ${reverse ? '' : ''}`}>
                  <div className={`lg:col-span-7 ${reverse ? 'lg:order-2' : ''}`}>
                    <div className="aspect-[16/10] rounded-3xl overflow-hidden">
                      <img src={IMAGES[i]} alt={it.t} className="w-full h-full object-cover" />
                    </div>
                  </div>
                  <div className={`lg:col-span-5 ${reverse ? 'lg:order-1' : ''}`}>
                    <div className="w-14 h-14 grid place-items-center rounded-2xl bg-forest/8 text-forest mb-5">
                      <Icon size={26} strokeWidth={1.6} />
                    </div>
                    <p className="overline mb-2">0{i + 1}</p>
                    <h2 className="font-heading text-3xl sm:text-4xl text-ink leading-tight tracking-tight">{it.t}</h2>
                    <p className="mt-4 text-ink-soft text-lg leading-relaxed">{it.d}</p>
                  </div>
                </div>
              </StaggerItem>
            );
          })}
        </Stagger>
      </section>
    </main>
  );
}
